export const subsection_external = 'external';
export const subsection_innstillingsradet = 'innstillingsradet';
export const subsection_finnmarkskommisjonen = 'finnmarkskommisjonen';
